// web/src/console/sections/BackupsSection.tsx
import type { JSX } from "react";
import { useState } from "react";
import { consoleApi } from "../../lib/consoleApi";
import { usePaged } from "../usePaged";
import { Pager } from "../Pager";
import { fmtRelative } from "../format";
import { CardTitle } from "../Term";
import { dataEntries } from "../../components/console/eventData";

export function BackupsSection(): JSX.Element {
  const backups = usePaged((off) => consoleApi.fetchEvents({ eventType: "db_backup", offset: off }).then((r) => r.events), []);
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div className="cc-card">
      <CardTitle>数据库备份</CardTitle>
      {backups.loading ? <div className="cc-skeleton" style={{ height: 200 }} /> :
       backups.error ? <div className="cc-empty">加载失败。 <button className="cc-back" onClick={backups.reload}>重试</button></div> :
       backups.rows.length === 0 ? <div className="cc-empty">暂无备份记录</div> :
       <>
         <table className="cc-table">
           <thead><tr><th>状态</th><th>时间</th><th>详情</th></tr></thead>
           <tbody>
             {backups.rows.map((e) => {
               const d = (e.data ?? {});
               const ok = d.result === "ok" || e.status === 200;
               const isOpen = open === e.id;
               return (
                 <tr key={e.id}>
                   <td><span className={`cc-health cc-health-${ok ? "ok" : "err"}`}><span className="cc-dot" />{ok ? "OK" : "FAIL"}</span></td>
                   <td>{fmtRelative(e.createdAt)}</td>
                   <td><button className="cc-link" onClick={() => setOpen(isOpen ? null : e.id)}>{isOpen ? "收起" : "详情"}{!ok && d.step ? ` — 失败步骤：${String(d.step)}` : ""}</button>
                     {isOpen && (
                       <div className="cc-detail">
                         {dataEntries(e.data).map((row) => (
                           <div key={row.key}>{row.key}: {row.href ? <a href={row.href} target="_blank" rel="noopener noreferrer">{row.value}</a> : row.value}</div>
                         ))}
                       </div>
                     )}
                   </td>
                 </tr>
               );
             })}
           </tbody>
         </table>
         <Pager page={backups.page} hasMore={backups.hasMore} onPrev={backups.prev} onNext={backups.next} loading={backups.loading} />
       </>}
    </div>
  );
}
